import { notBlank } from "../../widgets/forms/validators.js";
import AbstractFormStep from "../AbstractFormStep.js";

/**
 * Wizard step asking the user to enter a token or a key that will be used
 * for authentication.
 *
 * @param {renderable} label - Text for the token or key input
 * @param {predicate} hasToken - Weither the token or key already exists
 *   for this company
 * @param {string} attribute - The attribute of the input field
 */
export default class TokenStep extends AbstractFormStep {
	constructor({ label, hasToken, attribute }) {
		super(...arguments);

		this._label = label;
		this._hasToken = hasToken;
		this._attribute = attribute;
	}

	_shouldSubmitOnStart() {
		return this._hasToken();
	}

	_populateForm(form) {
		const input = form.input({
			label: this._label,
			attribute: this._attribute,
			validator: notBlank(),
		});

		input.register("input", () => {
			this.completed.trigger();
		});
	}
}
